// Page-load fetches must settle. A deploy blip or an aborted XHR (Axios
// "Network Error", status 0) would otherwise reject out of a lifecycle hook
// or a fire-and-forget loader and become an unhandled rejection.
export async function loadOrFallback(task, fallback, onError) {
	try {
		return await task()
	} catch (error) {
		console.error('Page load request failed:', error?.message || error)
		if (typeof onError === 'function') onError(error)
		return fallback
	}
}
